<template>
  <div class="teaching-arrange-schedule-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="detailInfo">
      <div class="header">
        <div class="prepend">
          <TeachingArrangeScheduleImport :extra-params="$attrs"
                                         @refresh="refreshGridData">
            <template #default="{toggleVisible}">
              <el-button size="mini"
                         type="primary"
                         plain
                         icon="el-icon-document-add"
                         @click="toggleVisible">导入排课</el-button>
            </template>
          </TeachingArrangeScheduleImport>
          <TeachingArrangeScheduleAdd :detail-info="detailInfo"
                                      :extra-params="$attrs"
                                      :map-key="mapConfig.mapKey"
                                      :circle-radius="mapConfig.maxSignDistance"
                                      @refresh="refreshGridData">
            <template #default="{toggleVisible}">
              <el-button size="mini"
                         type="primary"
                         plain
                         icon="el-icon-circle-plus-outline"
                         @click="toggleVisible">添加课程</el-button>
            </template>
          </TeachingArrangeScheduleAdd>
          <el-button size="mini"
                     type="primary"
                     plain
                     icon="el-icon-location-outline"
                     :disabled="committing || !selectedDetails.length"
                     @click="showBatchLocation">批量设置授课地点</el-button>
          <el-button size="mini"
                     type="primary"
                     plain
                     icon="el-icon-upload2"
                     :disabled="committing || !selectedSchedules.length"
                     @click="handleBatchChange(true)">批量发布</el-button>
          <el-button size="mini"
                     type="danger"
                     plain
                     icon="el-icon-download"
                     :disabled="committing || !selectedSchedules.length"
                     @click="handleBatchChange(false)">批量取消发布</el-button>
          <TeachingArrangeScheduleUpdate ref="update"
                                         :detail-info="detailInfo"
                                         :extra-params="$attrs"
                                         :map-key="mapConfig.mapKey"
                                         :circle-radius="mapConfig.maxSignDistance"
                                         @refresh="refreshGridData"></TeachingArrangeScheduleUpdate>
        </div>
      </div>
      <div class="body">
        <div class="body-cont"
             v-loading="committing"
             element-loading-text="数据处理中，请稍等...">
          <TeachingArrangeScheduleGrid ref="grid"
                                       :detail-info="detailInfo"
                                       :extra-params="$attrs"
                                       :map-config="mapConfig"
                                       @on-edit="handleEdit"
                                       @on-delete="handleDelete"
                                       @on-change="handleChange"
                                       @selection-change="handleSelectionChange"></TeachingArrangeScheduleGrid>
        </div>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>排课数据加载失败</div>
        <el-button type="text"
                   @click="loadDetailInfo">重新加载</el-button>
      </Hint>
    </template>
    <el-dialog title="批量设置授课地点"
               width="960px"
               top="6vh"
               custom-class="batch-location-dialog"
               :visible.sync="batchLocationVisible"
               :close-on-click-modal="false">
      <el-alert type="info"
                :closable="false"
                show-icon>
        已选择 {{selectedDetails.length}} 条排课明细，保存后将统一更新授课地点和地图坐标。
      </el-alert>
      <el-form class="batch-location-form"
               label-width="90px">
        <el-form-item label="授课地点"
                      required>
          <AddressSelector v-model="batchLocationForm.lessonPlace"
                           :coordinates="batchLocationForm.tencentMapLocation"
                           :site-id="$attrs.site"
                           :map-key="mapConfig.mapKey"
                           :circle-radius="mapConfig.maxSignDistance"
                           @address-change="handleBatchLocationChange">
          </AddressSelector>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small"
                   @click="batchLocationVisible = false">取消</el-button>
        <el-button size="small"
                   type="primary"
                   :loading="committing"
                   @click="submitBatchLocation">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import TeachingArrangeScheduleImport from './import'
import TeachingArrangeScheduleAdd from './add'
import TeachingArrangeScheduleUpdate from './update'
import TeachingArrangeScheduleGrid from './grid'
import AddressSelector from '../../../../../../widgets/tencent/AddressSelector'
import Hint from '../../../../../../elements/Hint'
export default {
  name: 'TeachingArrangeScheduleMain',
  components: {
    TeachingArrangeScheduleImport,
    TeachingArrangeScheduleAdd,
    TeachingArrangeScheduleUpdate,
    TeachingArrangeScheduleGrid,
    AddressSelector,
    Hint
  },
  data () {
    return {
      loading: false,
      detailInfo: null,
      committing: false,
      selectedDetails: [],
      selectedSchedules: [],
      batchLocationVisible: false,
      batchLocationForm: {
        lessonPlace: '',
        tencentMapLocation: ''
      },
      mapConfig: {
        mapKey: null,
        maxSignDistance: null
      }
    }
  },
  methods: {
    loadDetailInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/arrange/detailInfo',
        method: 'post',
        data: this.$qs.stringify(this.$attrs)
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.detailInfo = response.data['detailInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    queryMapConfig () {
      this.$ajax({
        url: '/support/thirdparty/tencent/map/queryTencentMapBaiscConfig',
        method: 'post'
      }).then(response => {
        if (response.data && response.data.responseCode === 'SUCCESS') {
          this.mapConfig.mapKey = response.data.mapKey
          this.mapConfig.maxSignDistance = response.data.maxSignDistance
          console.log('地图配置加载成功:', this.mapConfig)
        } else {
          const errorMessage = response.data.message || '地图配置加载失败'
          console.error('地图配置加载失败:', errorMessage)
          this.$message.error(errorMessage)
          throw new Error(errorMessage)
        }
      }).catch(error => {
        console.error('查询地图配置失败:', error)
        this.$message.error('地图配置查询失败，请检查网络连接或联系管理员')
        throw error
      })
    },
    refreshGridData () {
      this.selectedDetails = []
      this.selectedSchedules = []
      let grid = this.$refs.grid
      if (grid) {
        grid.queryArranges()
      }
    },
    handleEdit (row) {
      let update = this.$refs.update
      if (update) {
        update.showPopover(row)
      }
    },
    handleDelete (row) {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/arrange/delete/submit',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          detailsId: row.id
        }, this.$attrs))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.refreshGridData()
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleSelectionChange (details, schedules) {
      this.selectedDetails = details || []
      this.selectedSchedules = schedules || []
    },
    showBatchLocation () {
      if (!this.selectedDetails.length) {
        this.$message.warning('请先勾选要设置授课地点的排课明细')
        return
      }
      this.batchLocationForm = {
        lessonPlace: '',
        tencentMapLocation: ''
      }
      this.batchLocationVisible = true
    },
    handleBatchLocationChange (lessonPlace, tencentMapLocation) {
      this.batchLocationForm.lessonPlace = lessonPlace || ''
      this.batchLocationForm.tencentMapLocation = tencentMapLocation || ''
    },
    submitBatchLocation () {
      const lessonPlace = (this.batchLocationForm.lessonPlace || '').trim()
      if (!lessonPlace) {
        this.$message.warning('请输入或选择授课地点')
        return
      }
      const detailsIds = this.selectedDetails.map(detail => detail.id).filter(Boolean)
      if (!detailsIds.length) {
        this.$message.warning('请选择要设置授课地点的排课明细')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/arrange/location/batchSubmit',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          detailsIds,
          lessonPlace,
          tencentMapLocation: (this.batchLocationForm.tencentMapLocation || '').trim()
        }, this.$attrs), {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.batchLocationVisible = false
              this.$nextTick(() => {
                this.refreshGridData()
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleBatchChange (isPublish) {
      const selectedSchedules = this.selectedSchedules
      if (!selectedSchedules.length) {
        this.$message.warning('请先勾选要操作的课程')
        return
      }
      const actionName = isPublish ? '发布' : '取消发布'
      const hasSupply = !isPublish && selectedSchedules.some(schedule => !!schedule.supplyCount)
      const supplyTip = hasSupply ? '，对应的补修学生也将被删除' : ''
      this.$confirm(`确定要批量${actionName}选中的${selectedSchedules.length}门课程吗${supplyTip}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: isPublish ? 'warning' : 'error'
      }).then(() => {
        this.submitBatchChange(selectedSchedules, isPublish)
      }).catch(() => {})
    },
    submitBatchChange (selectedSchedules, isPublish) {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/arrange/change/batchSubmit',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          scheduleIds: selectedSchedules.map(schedule => schedule.id),
          isPublish
        }, this.$attrs), {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.refreshGridData()
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleChange (schedule, isPublish) {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/arrange/change/submit',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          scheduleId: schedule.id,
          isPublish
        }, this.$attrs))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.refreshGridData()
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  mounted () {
    this.loadDetailInfo()
    this.queryMapConfig()
  },
  activated () {
    this.refreshGridData()
  }
}
</script>

<style lang="scss">
  .teaching-arrange-schedule-main {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      display: flex;
      align-items: center;
      & > .prepend {
        margin: -5px -6px;
        flex: auto;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 12px 15px;
        .el-button {
          margin: 5px 6px;
          padding: 6px 15px 6px 10px;
          i {
            font-size: 14px;
            vertical-align: -1px;
          }
        }
      }
    }
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }

  .batch-location-dialog {
    max-width: calc(100vw - 48px) !important;
    max-height: 88vh;
    display: flex;
    flex-direction: column;

    > .el-dialog__header,
    > .el-dialog__footer {
      flex: none;
    }

    > .el-dialog__body {
      flex: auto;
      min-height: 0;
      overflow-y: auto;
      padding: 20px 28px 14px;
    }

    .batch-location-form {
      margin-top: 20px;
      padding-right: 8px;
    }
  }
</style>
